import { DropListButton, DropListButtonProps } from '@ketch-com/deck'
import { MenuItem } from './SubjectTypeDropList'

interface Props
  extends Omit<
    DropListButtonProps<{ label: string; value: string }, boolean, boolean, boolean>,
    'onChange' | 'options'
  > {
  onChange: (value?: string) => void
  useFunction: () => { data: any[]; isLoading: boolean }
  label: string
}

export const CodeDropList = ({ onChange, useFunction, label }: Props) => {
  const { data, isLoading } = useFunction()
  const options =
    data?.map(item => ({
      label: item.name || item.code,
      value: item.code,
    })) || []

  return (
    <DropListButton
      renderOption={(props, option, { selected }) => <MenuItem {...props} option={option} selected={selected} />}
      size="small"
      onChange={(_, item) => onChange(item?.value)}
      options={options}
      loading={isLoading}
      placeholder={isLoading ? 'Loading..' : `All ${label}`}
    />
  )
}
